export type Rect = { x: number; y: number; w: number; h: number };
export type Crop = {
  topLeft: { x: number; y: number };
  bottomRight: { x: number; y: number };
};
export const fullRegion: Rect = { x: 0, y: 0, w: 1, h: 1 };
export function validRegion(r: Rect) {
  return (
    Object.values(r).every(Number.isFinite) &&
    r.x >= 0 &&
    r.y >= 0 &&
    r.w > 0 &&
    r.h > 0 &&
    r.x + r.w <= 1.000001 &&
    r.y + r.h <= 1.000001
  );
}
/** Region is in displayed image coordinates; crop is in original pixel coordinates. */
export function traceCrop(
  crop: Crop | null,
  r: Rect,
  flipX = false,
  flipY = false,
): Crop {
  if (!validRegion(r)) throw new Error("Select an area inside the image.");
  const c = crop ?? { topLeft: { x: 0, y: 0 }, bottomRight: { x: 1, y: 1 } };
  const w = c.bottomRight.x - c.topLeft.x,
    h = c.bottomRight.y - c.topLeft.y;
  const x = flipX ? 1 - r.x - r.w : r.x,
    y = flipY ? 1 - r.y - r.h : r.y;
  return {
    topLeft: { x: c.topLeft.x + x * w, y: c.topLeft.y + y * h },
    bottomRight: {
      x: c.topLeft.x + (x + r.w) * w,
      y: c.topLeft.y + (y + r.h) * h,
    },
  };
}
